import React from "react";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import { useTranslation } from "react-i18next";
import { useReactToPrint } from "react-to-print";
import { Button } from "primereact/button";
import { RefObject } from "react";

interface PrintButtonProps {
  contentRef: RefObject<HTMLElement>;
}

const PrintButton: React.FC<PrintButtonProps> = ({ contentRef }) => {
  const { t } = useTranslation(["common"]);
  const handlePrint = useReactToPrint({ contentRef });
  return (
    <Button
      className="light-primary-btn d-flex gap-2 m-0"
      onClick={() => handlePrint()}
      label={t("print")}
      icon={<LocalPrintshopOutlinedIcon fontSize="small" />}
    />
  );
};

export default PrintButton;
